module.exports = __webpack_public_path__ + "static/page-header-backgound.a29a0cbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/page-header-backgound.jpg
// module id = 217
// module chunks = 22433821621997 31167082146650 235131596041995